import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LocationService {
	public onUrlChange = new Subject<{ url: string; state: any }>();

	constructor(private location: Location) {
		this.location.onUrlChange((url, state) => {
			this.onUrlChange.next({ url, state });
		});
	}
}
